import { MultiCombobox } from '~/components/uie-fix/MultiCombobox';
import { useFilterField } from '~/hooks';
import { useStaticProps } from '~/context';

export const CampusFilter = () => {
  const campusFilter = useFilterField('campusIds', 'PrimaryFilter');
  const {
    referenceData: { campuses },
  } = useStaticProps();

  return (
    <MultiCombobox
      value={campusFilter.value}
      aria-label="Campus"
      placeholder="Campus"
      onChange={(selectedItems) => campusFilter.setValue(selectedItems.filter((s) => !!s.trim()))}
      placeholderVariant="indicator"
    >
      {Object.entries(campuses).map(([id, { name }]) => (
        <MultiCombobox.Option label={name} value={id} key={id} />
      ))}
    </MultiCombobox>
  );
};
